<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="toc"><a id="page_iv"></a><a id="page_v"></a>Contents<br/></h1>
<p class="toc1">HarperCollins e-book exclusive extras:<br/></p>
<p class="toc1"><a id="RWTOC-7"></a><a href="#/xhtml/fm1#_RWTOC-7" style="color:blue">Hero of the Humdrum</a></p>
<p class="toc1"><a id="RWTOC-8"></a><a href="#/xhtml/fm2#_RWTOC-8" style="color:blue">The Giller Prize</a></p>
<p class="toc1"><a id="RWTOC-9"></a><a href="#/xhtml/fm3#_RWTOC-9" style="color:blue">Governor General’s Awards</a><br/></p>
<p class="toc"><a id="epi"></a><a href="#/xhtml/epi#epi" style="color:blue">Epigraph</a></p>
<p class="toc"><a id="RWTOC-1"></a><a href="#/xhtml/chapter1#_RWTOC-1" style="color:blue">1934</a>   Nora left for New York City today.</p>
<p class="toc"><a id="RWTOC-2"></a><a href="#/xhtml/chapter2#_RWTOC-2" style="color:blue">1935</a>   Thank you for the brooch.</p>
<p class="toc"><a id="RWTOC-3"></a><span href="#/xhtml/chapter3#_RWTOC-3" style="color:blue" title="Link target outside of Sample">1936</span>   Happy New Year!!!</p>
<p class="toc"><a id="RWTOC-4"></a><span href="#/xhtml/chapter4#_RWTOC-4" style="color:blue" title="Link target outside of Sample">1937</span>   A blustery day and I spent a good part of the afternoon visiting. . .</p>
<p class="toc"><a id="RWTOC-5"></a><span href="#/xhtml/chapter5#_RWTOC-5" style="color:blue" title="Link target outside of Sample">1938</span>   Awakened in the night by the wind and this morning I looked out. . .</p>
<p class="toc"><a id="RWTOC-6"></a><span href="#/xhtml/bm#_RWTOC-6" style="color:blue" title="Link target outside of Sample">Afterword</span></p>
<p class="toc"><a id="ata-1"></a><span href="#/xhtml/ata#ata" style="color:blue" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><a id="adc-1"></a><span href="#/xhtml/adc#also" style="color:blue" title="Link target outside of Sample">Also by Richard B. Wright</span></p>
<p class="toc"><a id="cre-1"></a><span href="#/xhtml/cre#cred" style="color:blue" title="Link target outside of Sample">Credits</span></p>
<p class="toc"><a id="cop-1"></a><span href="#/xhtml/cop#copy" style="color:blue" title="Link target outside of Sample">Copyright</span></p>
<p class="toc"><a id="atp-1"></a><span href="#/xhtml/atp#atp" style="color:blue" title="Link target outside of Sample">About the Publisher</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?fc21726c